import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import { app } from '../../utils/store';

gsap.registerPlugin(ScrollTrigger);

export default class Tease{
    constructor(){
        this.header = document.querySelector('header');

        this.gallery = {
            container: document.getElementById('gallery'),
            article: document.querySelectorAll('#gallery article'),
        };
    }

    init() {
        this.animation();
        this.hovering();
    }

    hovering = () => {
        this.gallery.article.forEach((toggler) => {
            toggler.addEventListener('mouseover', (e) => {
                this.gallery.container.classList.add('hovering');
                toggler.classList.add('active');
            });

            toggler.addEventListener('mouseleave', (e) => {
                this.gallery.container.classList.remove('hovering');
                toggler.classList.remove('active');
            });
        });
    }

    animation = () => {
        this.gallery.article.forEach((image) => {
            gsap.fromTo(image, 2,{
                y: 200,
                autoAlpha: 0,
            },{
                y: 0,
                autoAlpha: 1,
                stagger: .05,
                ease: 'expo.easeInOut',
                scrollTrigger: {
                    trigger: image,
                    start: 'top bottom',
                    end: 'center 80%',
                    toggleActions: "play none play reverse",
                    scrub: .3,
                },
            });
        });
    }
}
